import { useHistory, useLocation } from "react-router";
import { RouteUtils } from "utilities/route-utils";
import UserBookmarkCountSortOption from "../../../../models/enumerations/sorting/user-bookmarks/user-bookmark-count-sort-option";
import UserBookmarkSortOption from "../../../../models/enumerations/sorting/user-bookmarks/user-bookmark-sort-option";
import useMyLiNKDefaults from "utilities/hooks/domain/my-link/use-my-link-defaults";
import { BookmarkUtils } from "utilities/bookmark-utils";

const countSortOptionToBookmarkSortOption: Record<
    UserBookmarkCountSortOption,
    UserBookmarkSortOption
> = {
    [UserBookmarkCountSortOption.BookmarkCreatedOnAscending]:
        UserBookmarkSortOption.CreatedOnAscending,
    [UserBookmarkCountSortOption.BookmarkCreatedOnDescending]:
        UserBookmarkSortOption.CreatedOnDescending,
    [UserBookmarkCountSortOption.BookOrder]: UserBookmarkSortOption.BookOrder,
    [UserBookmarkCountSortOption.Collection]:
        UserBookmarkSortOption.CreatedOnDescending,
};

const useSortBookmarks = (paramIdToAppend?: string | number) => {
    const { pathname, search } = useLocation();
    const { replace } = useHistory();

    const {
        getBookmarkSortUserSettingForGrouping,
        setBookmarkSortUserSettingForGrouping,
    } = useMyLiNKDefaults();

    const groupId = BookmarkUtils.getGroupingByPath();

    const defaultSort = getBookmarkSortUserSettingForGrouping(
        groupId ? Number(groupId) : undefined
    );

    const sortByKey = paramIdToAppend ? `sortBy_${paramIdToAppend}` : "sortBy";

    const {
        [sortByKey]: countSortBy = defaultSort ??
            UserBookmarkCountSortOption.BookmarkCreatedOnDescending,
    } = RouteUtils.queryStringToObject<{
        [sortByKey]: UserBookmarkCountSortOption;
    }>(search);

    const sortBy =
        countSortOptionToBookmarkSortOption[countSortBy] ??
        UserBookmarkSortOption.CreatedOnDescending;

    const onSortByChange = async (newVal) => {
        const { [sortByKey]: oldSortBy, ...otherParams } =
            RouteUtils.queryStringToObject<{
                [key: string]: any;
            }>(search);
        await setBookmarkSortUserSettingForGrouping(
            newVal,
            groupId ? Number(groupId) : undefined
        );
        replace(
            RouteUtils.appendQueryParams(pathname, {
                ...otherParams,
                [sortByKey]: newVal,
            })
        );
    };

    return {
        sortBy,
        onSortByChange,
        sortByKey,
    };
};

export default useSortBookmarks;
